export default "__VITE_ASSET__C2oh86EU__"